import { render, staticRenderFns } from "./PageVisitsTable.vue?vue&type=template&id=9651d926"
import script from "./PageVisitsTable.vue?vue&type=script&lang=js"
export * from "./PageVisitsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports